import classnames from "classnames"
import React from "react"
import ThreadFlags from "../ThreadFlags"
import ThreadReplies from "../ThreadReplies"
import ThreadsListItemActivity from "./ThreadsListItemActivity"
import ThreadsListItemCategory from "./ThreadsListItemCategory"
import ThreadsListItemCheckbox from "./ThreadsListItemCheckbox"
import ThreadsListItemLastPoster from "./ThreadsListItemLastPoster"
import ThreadsListItemNotifications from "./ThreadsListItemNotifications"
import ThreadsListItemReadStatus from "./ThreadsListItemReadStatus"
import ThreadsListItemStarter from "./ThreadsListItemStarter"
import ThreadsListItemTitle from "./ThreadsListItemTitle"

const ThreadsListItem = ({
  activeCategory,
  categories,
  showOptions,
  showNotifications,
  thread,
  isBusy,
  isSelected,
}) => {
  let parent = null
  let category = null

  if (activeCategory.id !== thread.category) {
    category = categories[thread.category]

    if (
      category.parent &&
      category.parent !== activeCategory.id &&
      categories[category.parent] &&
      !categories[category.parent].special_role
    ) {
      parent = categories[category.parent]
    }
  }

  const hasFlags =
    thread.is_closed ||
    thread.is_hidden ||
    thread.is_unapproved ||
    thread.weight > 0 ||
    thread.best_answer ||
    thread.has_poll ||
    thread.has_unapproved_posts

  const isNew = showOptions ? thread.is_new : false

  return (
    <li
      className={classnames("list-group-item threads-list-item modern-thread-card", {
        "threads-list-item-is-busy": isBusy,
        "threads-list-item-is-new": isNew,
      })}
    >
      {/* Left Section - User Avatar and Info */}
      <div className="thread-card-avatar-section">
        <div className="thread-card-avatar">
          <ThreadsListItemStarter thread={thread} />
        </div>
      </div>

      {/* Main Content Section */}
      <div className="thread-card-content">
        {/* Header with Read Status and Title */}
        <div className="thread-card-header">
          {showOptions && (
            <div className="thread-card-read-status">
              <ThreadsListItemReadStatus thread={thread} />
            </div>
          )}
          <div className="thread-card-title-wrapper">
            <ThreadsListItemTitle thread={thread} isNew={isNew} />
          </div>
        </div>

        {/* Meta Information - Flags and Categories */}
        <div className="thread-card-meta">
          {hasFlags && (
            <div className="thread-card-flags">
              <ThreadFlags thread={thread} />
            </div>
          )}
          {!!category && (
            <div className="thread-card-category">
              <ThreadsListItemCategory parent={parent} category={category} />
            </div>
          )}
        </div>

        {/* Stats - Replies and Last Activity */}
        <div className="thread-card-stats">
          <div className="thread-card-replies">
            <ThreadReplies thread={thread} />
          </div>
          <div className="thread-card-last-info">
            <ThreadsListItemLastPoster thread={thread} />
            <ThreadsListItemActivity thread={thread} />
          </div>
        </div>
      </div>

      {/* Right Section - Actions and Notifications */}
      <div className="thread-card-actions">
        {showOptions && showNotifications && (
          <div className="thread-card-notification">
            <ThreadsListItemNotifications
              disabled={isBusy}
              thread={thread}
            />
          </div>
        )}
        {showOptions && thread.moderation.length > 0 && (
          <div className="thread-card-checkbox">
            <ThreadsListItemCheckbox
              checked={isSelected}
              disabled={isBusy}
              thread={thread}
            />
          </div>
        )}
      </div>
    </li>
  )
}

export default ThreadsListItem
